import { Tooltip } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import React from 'react';

import { IconV2 } from '~/src/dash/components/icons/IconV2';
import { borderRadius, Col, Cols, spacing, Text } from '~/src/dash/publicaUI';
import { convertLargeNumbersToRoundedString } from '~/src/dash/utils/basic';
import { publicaColors } from '~/src/dash/utils/colors';
import { LoadingState, LoadingStateLoading } from '~/src/dash/utils/loading-states';

interface IForecastingCardProps {
  icon: string;
  name: string;
  value: number;
  loadState: LoadingState;
  tooltip?: string;
  onClick?: () => void;
}

export const ForecastingCard = (props: IForecastingCardProps) => {
  const { icon, name, value, tooltip = '', onClick, loadState } = props;

  return (
    <Tooltip title={tooltip} placement='top'>
      <div onClick={() => onClick && onClick()}>
        <Cols
          extraSmallVerticalPadding
          smallHorizontalPadding
          gap={spacing.base}
          style={{
            alignItems: 'center',
            width: 'fit-content',
            border: `1px solid ${publicaColors.lightGray}`,
            borderRadius: borderRadius.base,
          }}
        >
          <Col>
            <Cols
              gap={spacing.small}
              style={{
                alignItems: 'center',
              }}
            >
              <Col displayFlex>
                <IconV2 small name={icon} color={publicaColors.black} />
              </Col>
              <Col>
                <Text small color={publicaColors.veryDarkGray}>
                  {name}
                </Text>
              </Col>
            </Cols>
          </Col>
          <Col>
            {loadState === LoadingStateLoading ? (
              <Skeleton variant='text' animation='wave' width={40} height={28} />
            ) : (
              <Text heavy color={publicaColors.veryDarkGray}>
                {convertLargeNumbersToRoundedString(value)}
              </Text>
            )}
          </Col>
        </Cols>
      </div>
    </Tooltip>
  );
};
